export const getHtmlUnit =(unit) =>{
    let htmlUnit :string='';
    switch(unit){
        case 'm2':
            htmlUnit = 'm<sup>2</sup>';
            break;
        case 'm3':
            htmlUnit = 'm<sup>3</sup>';
            break;

        default:
            htmlUnit =  unit;
    }

    return htmlUnit;
}









